export default "__VITE_ASSET__B2jcRy23__"